import React, { Component } from "react";
import { Link } from "react-router-dom";
import { UserActions } from "./UserActions";
import { allLoaded } from "../store/reducers";
import { connect } from "react-redux";
import styled, { createGlobalStyle } from "styled-components";
import { Logo } from "./Logo";
import { LoadingPage } from "../pages/LoadingPage";
import { mainFontColour } from "./styles";

const GlobalStyle = createGlobalStyle`
    body {
        background-color: #EEE;
        height: 100%;
    }
    #root {
        height: 100%;
    }
`;

const LayoutContainer = styled.div`
    color: ${mainFontColour};
    font-family: "Avenir", "Avenir Next", "Lato", sans-serif;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const AppHeader = styled.header`
    width: 100%;
    background-color: rgb(61, 100, 157);
    box-shadow: rgb(28, 47, 76) 0px -1.5rem 3rem -1rem inset;
    color: white;
    padding: ${({ thinHeader }) => (thinHeader ? "0.25rem 1rem" : "1rem")};
    z-index: 99;
    ${({ thinHeader }) =>
        thinHeader
            ? `
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
    `
            : "text-align: center;"};
`;

const HomeDiv = styled.div`
    ${({ thinHeader }) =>
        thinHeader ? "margin-top: 1rem;" : "margin-right: auto;"};
`;

const AppTitle = styled.h1`
    font-size: 1.5rem;
    letter-spacing: 0.1rem;
    margin: 0;
    display: inline-block;
`;

const Content = styled.div`
    padding-top: 1.5rem;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 5rem;
    font-size: large;
    flex: 1;
    overflow: auto;
`;

const HeaderLink = styled(Link)`
    color: white !important;
    text-decoration: none !important;
`;

class Layout extends Component {
    componentDidCatch(error, info) {
        this.props.logError({ stack: error.stack, info });
    }

    render() {
        const { children, allLoaded, thinHeader } = this.props;
        if (allLoaded) {
            return (
                <LayoutContainer>
                    <GlobalStyle/>
                    <AppHeader thinHeader={thinHeader}>
                        <UserActions />
                        <HomeDiv>
                            {!thinHeader && (
                                <Link to="/">
                                    <Logo />
                                </Link>
                            )}
                            <div>
                                <HeaderLink to="/">
                                    <AppTitle>Onews</AppTitle>
                                </HeaderLink>
                            </div>
                        </HomeDiv>
                    </AppHeader>
                    <Content id="content">{children}</Content>
                </LayoutContainer>
            );
        }
        return <LoadingPage />;
    }
}

const mapState = state => ({
    allLoaded: allLoaded(state)
});

const dispatchActions = {
    logError: error => ({
        type: "LOG_ERROR",
        error
    })
};

Layout = connect(
    mapState,
    dispatchActions
)(Layout);

export { Layout };



// WEBPACK FOOTER //
// ./src/components/Layout.js